import React, { useContext } from "react";
import MapContext from "../context/MapContext";
import { Popup as PinPopup } from "react-leaflet";
import { useMediaQuery } from "react-responsive";
import { Sizes } from "../../../styles";

// we never see this component
// this component helps the map pan to a pin when a location is selected.
// the functionality of the panning is built into the leaflet package

const Popup = () => {
	const {
		data: { selectedLocation },
	} = useContext(MapContext);

	const isDesktop = useMediaQuery({
		query: `(min-width: ${Sizes.screens.large})`,
	});

	if (
		!selectedLocation ||
		!selectedLocation.pins ||
		!selectedLocation?.pins.length
	)
		return null;

	const panPaddingValues = isDesktop ? [900, 500] : [100, 200];

	return (
		<PinPopup
			position={selectedLocation.pins[0]}
			autoPanPadding={panPaddingValues}
		>
			Popup
		</PinPopup>
	);
};

export default Popup;
